var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qrcode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H9C10.1046 3 11 3.89543 11 5V9C11 10.1046 10.1046 11 9 11H5C3.89543 11 3 10.1046 3 9V5ZM9 5H5V9H9V5ZM13 5C13 3.89543 13.8954 3 15 3H19C20.1046 3 21 3.89543 21 5V9C21 10.1046 20.1046 11 19 11H15C13.8954 11 13 10.1046 13 9V5ZM19 5H15V9H19V5ZM7 6C7.55228 6 8 6.44772 8 7V7.01C8 7.56228 7.55228 8.01 7 8.01C6.44772 8.01 6 7.56228 6 7.01V7C6 6.44772 6.44772 6 7 6ZM17 6C17.5523 6 18 6.44772 18 7V7.01C18 7.56228 17.5523 8.01 17 8.01C16.4477 8.01 16 7.56228 16 7.01V7C16 6.44772 16.4477 6 17 6ZM3 15C3 13.8954 3.89543 13 5 13H9C10.1046 13 11 13.8954 11 15V19C11 20.1046 10.1046 21 9 21H5C3.89543 21 3 20.1046 3 19V15ZM13 14C13 13.4477 13.4477 13 14 13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H15V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V14ZM20 13C20.5523 13 21 13.4477 21 14V14.01C21 14.5623 20.5523 15.01 20 15.01C19.4477 15.01 19 14.5623 19 14.01V14C19 13.4477 19.4477 13 20 13ZM5 15V19H9V15H5ZM7 16C7.55228 16 8 16.4477 8 17V17.01C8 17.5623 7.55228 18.01 7 18.01C6.44772 18.01 6 17.5623 6 17.01V17C6 16.4477 6.44772 16 7 16ZM16 17C16 16.4477 16.4477 16 17 16H20C20.5523 16 21 16.4477 21 17V20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20V18H17C16.4477 18 16 17.5523 16 17ZM13 20C13 19.4477 13.4477 19 14 19H17C17.5523 19 18 19.4477 18 20C18 20.5523 17.5523 21 17 21H14C13.4477 21 13 20.5523 13 20Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.9d19fd4bf7753a601c8075820fa99f69.svg";
export { ForwardRef as ReactComponent };